// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"24\" viewBox=\"0 0 20 24\"> <path id=\"Polygon_2\" data-name=\"Polygon 2\" d=\"M10.285,2.858a2,2,0,0,1,3.43,0l8.468,14.113A2,2,0,0,1,20.468,20H3.532a2,2,0,0,1-1.715-3.029Z\" transform=\"translate(20) rotate(90)\" fill=\"#1c539f\"/> </svg> ";
// Exports
module.exports = code;